// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_WALL = "Ze\u010f";
